<template>
<div class="container setting-page">
    <v-head></v-head>
    <v-left current="logistics"></v-left>
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- <el-tab-pane label="项目" name="project"></el-tab-pane> -->
        <el-tab-pane label="店铺" name="applets"></el-tab-pane>
        <!-- <el-tab-pane label="商户" name="merchant"></el-tab-pane> -->
        <el-tab-pane label="物流" name="logistics_setting"></el-tab-pane>
        <el-tab-pane label="用户" name="members"></el-tab-pane>
        <el-tab-pane label="语言" name="language"></el-tab-pane>
        <el-tab-pane label="关于" name="aboutUs"></el-tab-pane>
    </el-tabs>        
    <component :is="activeName"></component>
</div>
</template>
<script>

import head from '@/pages/public/_head'
import left from '@/pages/public/_left'
import project from '@/pages/setting/project/_list'
import applets from '@/pages/setting/applets/_list'
import merchant from '@/pages/setting/merchant/_list'
import language from '@/pages/setting/language/_list'
import aboutUs from '@/pages/setting/aboutUs/_list'
import members from '@/pages/setting/members/_list'
import logistics_setting from '@/pages/logistics/setting/_list_company'
export default {
  components: {
    'v-head':head,
    'v-left': left,
    project,applets,merchant,language,aboutUs,members,logistics_setting
  },
  data(){
    return {
      activeName:'applets',
    }
  },
  methods:{
    handleClick(e){
      
    },
  },
  mounted(){
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/setting/Index.vue